import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "with-side-panel" }
const _hoisted_2 = { class: "content-i" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "element-wrapper" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = { class: "element-header" }
const _hoisted_7 = { class: "element-box" }
const _hoisted_8 = { class: "form-header" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-7 col-md-12" }
const _hoisted_11 = { class: "form-section shadow-sm mb-4" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "form-section shadow-sm mb-4 bg-light-blue" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "col-md-6 mt-3" }
const _hoisted_22 = { class: "col-md-6 mt-3" }
const _hoisted_23 = { class: "col-12 mt-3" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "text-muted ms-3" }
const _hoisted_26 = {
  key: 0,
  class: "col-12 mt-3"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-section shadow-sm" }
const _hoisted_31 = { class: "col-lg-5 col-md-12 mt-4 mt-lg-0" }
const _hoisted_32 = { class: "form-section shadow-sm h-100" }
const _hoisted_33 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_34 = { class: "flex-grow-1" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_37 = { class: "row gx-2 gy-3" }
const _hoisted_38 = { class: "col-12 col-xxl-6" }
const _hoisted_39 = { class: "col-12 col-xxl-6" }
const _hoisted_40 = {
  key: 0,
  class: "text-center text-muted p-5"
}
const _hoisted_41 = { class: "form-buttons-w text-center" }

import courseGroupCoachingService from '@/api/Course/GroupCoaching';
import userService from '@/api/User';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import CreateButton from '@/components/CreateButton.vue';
import Sidebar from '@/components/FormSidebar.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
// @ts-ignore
import {getClientDropdown, getOfficeDropdown, getUserDropdown} from '@/shared/dropdowns';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import useVuelidate from '@vuelidate/core';
import {helpers} from '@vuelidate/validators';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import {ICourseGroupCoaching} from "@/interfaces/Course/GroupCoaching/ICourseGroupCoaching";
import BaseToggle from "@/components/base/BaseToggle.vue";
import BackButton from "@/components/button/BackButton.vue";
import SaveButton from "@/components/button/SaveButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const {t} = useI18n();
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const operationTypeDropdown = ref([]);
const officeDropdown = ref([]);
const clientDropdown = ref([]);
const coachDropdown = ref([]);
const coachBillingTypeDropdown = ref([]);
const isSubmitting = ref(false);
const isLoaded = ref(false);
const route = useRoute();
const courseId = route.params.id;

const formData = ref<ICourseGroupCoaching>({
  nameOfCoaching: '',
  operationType: '',
  actionNumber: '',
  startDate: '',
  endDate: '',
  units: null,
  cost: null,
  taxExempt: true,
  costWithTaxes: null,
  taxPercentage: null,
  officeId: null,
  clientIds: [],
  coaches: [],
});

const rules = ref({
  nameOfCoaching: requiredRule(t),
  operationType: requiredRule(t),
  actionNumber: requiredRule(t),
  startDate: requiredRule(t),
  endDate: requiredRule(t),
  units: requiredRule(t),
  cost: requiredRule(t),
  officeId: requiredRule(t),
  clientIds: requiredRule(t),
  coaches: {
    $each: helpers.forEach({
      coachId: requiredRule(t),
      billingType: requiredRule(t),
      cost: requiredRule(t),
    }),
  },
});


watch(
    [() => formData.value.taxExempt, () => formData.value.cost],
    ([isExempt, newCost]) => {
      if (isExempt) {
        formData.value.taxPercentage = 0;
        formData.value.costWithTaxes = newCost;
      } else {
        formData.value.taxPercentage = 19;
        if (newCost) {
          const total = Number(newCost) * 1.19;
          formData.value.costWithTaxes = Number(total.toFixed(4));
        } else {
          formData.value.costWithTaxes = null;
        }
      }
    },
    {immediate: true}
);

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (courseId) {
      await courseGroupCoachingService.putCourse(formData.value, +courseId);
    } else {
      await courseGroupCoachingService.postCourse(formData.value);
    }

    await router.push({name: 'courseGroupCoachingList'});
    isSubmitting.value = false;

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getCourse() {
  try {
    const {data} = await courseGroupCoachingService.getCourse(+courseId);
    const officeId = data.data.location.id;
    const clients = data.data.clients || [];
    const clientArray = clients
        .map((client: any) => client?.id)
        .filter((id: number | null) => id != null);
    const coaches = data.data.coaches || [];
    const coachesArray = coaches.map((item: any) => ({
      coachId: item.id,
      engagementType: item.engagementType,
      billingType: item.billingType !== null ? item.billingType : 'null',
      cost: item.cost !== null ? item.cost : 0,
    }));

    formData.value = {...data.data, clientIds: clientArray, officeId: officeId, coaches: coachesArray};
  } catch (error) {
    await ErrorToast(error);
  }
}

async function addCoach() {
  formData.value.coaches.push({coachId: '', billingType: '', cost: '', engagementType: ''});
  v$.value.$touch();
}

async function deleteCoach(index: number) {
  formData.value.coaches.splice(index, 1);
}

async function onSelectCoach(coachId: string | number, index: number) {
  try {
    if (coachId !== undefined && coachId !== '' && coachId !== null) {
      const {data} = await userService.getUser(+coachId);
      const user = data.data.user;

      formData.value.coaches[index].engagementType = user.engagementType;

      if (user.engagementType === 'intern') {
        formData.value.coaches[index].billingType = 'null';
        formData.value.coaches[index].cost = 0;
      }
    } else {
      await deleteCoach(index);
    }

  } catch (error) {
    await ErrorToast(error);
  }
}

async function getCourseGroupCoachingEnumDropdowns() {
  operationTypeDropdown.value = getEnums?.value?.groupCoachingOperationTypes || [];
  coachBillingTypeDropdown.value = getEnums?.value?.coachBillingTypes || [];
}

onMounted(async () => {
  //if (Object.keys(getEnums.value).length === 0) {
  //  await store.dispatch('getEnums', { t });
  //}

  await Promise.all([
    getCourseGroupCoachingEnumDropdowns(),
    getUserDropdown(coachDropdown),
    getOfficeDropdown(officeDropdown),
    getClientDropdown(clientDropdown),
  ]);

  if (courseId) {
    await getCourse();
  }

  isLoaded.value = true;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BackButton, {
            label: _ctx.$t('general.button.back'),
            to: { name: 'courseGroupCoachingList' },
            marginBottom: "5"
          }, null, 8, ["label"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.$t('course.general_title')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$t('course.group_coaching.title')), 1),
            (isLoaded.value)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  onSubmit: _withModifiers(submitForm, ["prevent"]),
                  novalidate: "",
                  class: "form-styled"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[12] || (_cache[12] = _createElementVNode("h6", { class: "section-title" }, "Allgemeine Informationen", -1)),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(BaseInput, {
                              modelValue: formData.value.nameOfCoaching,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.nameOfCoaching) = $event)),
                              label: "Bezeichnung",
                              required: true,
                              validation: _unref(v$).nameOfCoaching,
                              messages: _unref(v$).nameOfCoaching.required.$message
                            }, null, 8, ["modelValue", "validation", "messages"])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            (operationTypeDropdown.value?.length)
                              ? (_openBlock(), _createBlock(SelectVue, {
                                  key: 0,
                                  modelValue: formData.value.operationType,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.operationType) = $event)),
                                  options: operationTypeDropdown.value,
                                  label: "Maßnahmenart",
                                  required: true,
                                  validation: _unref(v$).operationType,
                                  messages: _unref(v$).operationType.required.$message
                                }, null, 8, ["modelValue", "options", "validation", "messages"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(BaseInput, {
                              modelValue: formData.value.actionNumber,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.actionNumber) = $event)),
                              label: "Maßnahmennummer",
                              required: true,
                              validation: _unref(v$).actionNumber,
                              messages: _unref(v$).actionNumber.required.$message
                            }, null, 8, ["modelValue", "validation", "messages"])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            (officeDropdown.value?.length)
                              ? (_openBlock(), _createBlock(SelectVue, {
                                  key: 0,
                                  modelValue: formData.value.officeId,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.officeId) = $event)),
                                  options: officeDropdown.value,
                                  label: "Standort",
                                  required: true,
                                  validation: _unref(v$).officeId,
                                  messages: _unref(v$).officeId.required.$message
                                }, null, 8, ["modelValue", "options", "validation", "messages"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[13] || (_cache[13] = _createElementVNode("h6", { class: "section-title" }, "Zeitraum & Finanzen", -1)),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(Datepicker, {
                              modelValue: formData.value.startDate,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.startDate) = $event)),
                              label: "Start",
                              required: true,
                              validation: _unref(v$).startDate,
                              messages: _unref(v$).startDate.required.$message
                            }, null, 8, ["modelValue", "validation", "messages"])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(Datepicker, {
                              modelValue: formData.value.endDate,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.endDate) = $event)),
                              label: "Ende",
                              required: true,
                              validation: _unref(v$).endDate,
                              messages: _unref(v$).endDate.required.$message
                            }, null, 8, ["modelValue", "validation", "messages"])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(BaseNumber, {
                              modelValue: formData.value.units,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.units) = $event)),
                              label: "Einheiten (Gesamt)",
                              required: true,
                              validation: _unref(v$).units,
                              messages: _unref(v$).units.required.$message
                            }, null, 8, ["modelValue", "validation", "messages"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(BaseNumber, {
                              modelValue: formData.value.cost,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.cost) = $event)),
                              label: "Preis exkl. USt",
                              isCurrency: true,
                              decimalPlaces: 4,
                              required: true,
                              validation: _unref(v$).cost,
                              messages: _unref(v$).cost.required.$message
                            }, null, 8, ["modelValue", "validation", "messages"])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(BaseToggle, {
                                modelValue: formData.value.taxExempt,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.taxExempt) = $event)),
                                label: "Umsatzsteuerbefreit"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("small", _hoisted_25, " (" + _toDisplayString(formData.value.taxExempt ? 'Steuerfrei (Umsatzsteuer exkludiert)' : 'Steuerpflichtig (Umsatzsteuer inkludiert)') + ") ", 1)
                            ])
                          ]),
                          (!formData.value.taxExempt)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createVNode(BaseNumber, {
                                      modelValue: formData.value.taxPercentage,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.taxPercentage) = $event)),
                                      label: "USt (%)",
                                      disabled: true
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_29, [
                                    _createVNode(BaseNumber, {
                                      modelValue: formData.value.costWithTaxes,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.costWithTaxes) = $event)),
                                      label: "Preis inkl. USt.",
                                      isCurrency: true,
                                      decimalPlaces: 4,
                                      disabled: true
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[14] || (_cache[14] = _createElementVNode("h6", { class: "section-title" }, "Teilnehmer", -1)),
                        (clientDropdown.value?.length)
                          ? (_openBlock(), _createBlock(SelectVue, {
                              key: 0,
                              modelValue: formData.value.clientIds,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.clientIds) = $event)),
                              options: clientDropdown.value,
                              "is-multi": true,
                              required: true,
                              label: _ctx.$t('placeholder.client_name'),
                              validation: _unref(v$).clientIds,
                              messages: _unref(v$).clientIds.required.$message
                            }, null, 8, ["modelValue", "options", "label", "validation", "messages"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-3" }, [
                          _createElementVNode("h6", { class: "section-title mb-0" }, "Zugeordnete Coaches")
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.coaches, (coach, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "coach-card mb-3 p-3 border rounded shadow-sm"
                          }, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createVNode(SelectVue, {
                                  modelValue: coach.coachId,
                                  "onUpdate:modelValue": [($event: any) => ((coach.coachId) = $event), ($event: any) => (onSelectCoach(coach.coachId, index))],
                                  options: coachDropdown.value,
                                  label: "Coach",
                                  placeholder: "Coach wählen",
                                  validation: _unref(v$).coaches?.$each?.$response?.$data[index]?.coachId,
                                  messages: _unref(v$).coaches?.$each?.$response?.$errors[index]?.coachId[0]?.$message
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "validation", "messages"])
                              ]),
                              _createElementVNode("button", {
                                class: "btn btn-link text-danger p-0 ml-2",
                                onClick: ($event: any) => (deleteCoach(index))
                              }, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("i", {
                                  class: "os-icon os-icon-trash",
                                  style: {"font-size":"1.3rem"}
                                }, null, -1)
                              ]))], 8, _hoisted_35)
                            ]),
                            (coach?.engagementType === 'extern')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createVNode(SelectVue, {
                                        modelValue: coach.billingType,
                                        "onUpdate:modelValue": ($event: any) => ((coach.billingType) = $event),
                                        options: coachBillingTypeDropdown.value,
                                        "is-clear": true,
                                        required: true,
                                        label: "Abrechnungsart",
                                        placeholder: "Wählen...",
                                        validation: _unref(v$).coaches.$each.$response.$data[index]?.billingType,
                                        messages: _unref(v$).coaches.$each.$response.$errors[index]?.billingType[0]?.$message
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "validation", "messages"])
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                      _createVNode(BaseNumber, {
                                        modelValue: coach.cost,
                                        "onUpdate:modelValue": ($event: any) => ((coach.cost) = $event),
                                        label: "Kosten",
                                        decimalPlaces: 2,
                                        required: true,
                                        isCurrency: true,
                                        validation: _unref(v$).coaches.$each.$response.$data[index]?.cost,
                                        messages: _unref(v$).coaches.$each.$response.$errors[index]?.cost[0]?.$message
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "validation", "messages"])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        _createElementVNode("div", { class: "text-center mt-3 mb-3" }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-primary btn-sm",
                            onClick: addCoach
                          }, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("i", { class: "os-icon os-icon-plus" }, null, -1),
                            _createTextVNode(" Hinzufügen ", -1)
                          ]))])
                        ]),
                        (!formData.value.coaches.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("i", {
                                class: "os-icon os-icon-user-check d-block mb-2",
                                style: {"font-size":"2rem"}
                              }, null, -1),
                              _createTextVNode(" Keine Coaches zugewiesen ", -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(SaveButton, {
                      label: _ctx.$t('general.button.save'),
                      loading: isSubmitting.value
                    }, null, 8, ["label", "loading"])
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(Sidebar)
    ])
  ]))
}
}

})